export default __webpack_public_path__ + "static/media/People-bro.b520afc0.svg";